import React, { useEffect } from "react";
import {
  Route,
  Routes as ReactRoutes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Landing from "./pages/Landing/Landing";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import NotFound from "./pages/NotFound/NotFound";
import Product from "./pages/Product/Product";
import ClearVAT from "./pages/ClearVAT/ClearVAT";
import ClearCustoms from "./pages/ClearCustoms/ClearCustoms";
import SPOT from "./pages/SPOT/SPOT";
import VATRules from "./pages/VATRules/VATRules";
import CheckVATID from "./pages/CheckVATID/CheckVATID";
import Suite from "./pages/Suite/Suite";

export default function Routes() {
  const RedirectToDefaultLanguage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
      const language = location.pathname.split("/")[2];
      if (!localStorage.getItem("lang") && !language) {
        navigate("/store/de", { replace: true });
      } else if (localStorage.getItem("lang")) {
        navigate(`/store/${localStorage.getItem("lang")}`, { replace: true });
      }
    }, [navigate, location]);
    return null;
  };

  return (
    <body
      data-container="body"
      id="html-body"
      itemType="http://schema.org/Product"
      itemScope="itemscope"
      className="catalog-product-view product-clearvat page-layout-1column"
    >
      <Header />
      <ReactRoutes>
        <Route exact path="/store/:language" element={<Landing />} />
        <Route exact path="/store/:language/vat-suite" element={<Suite />} />
        <Route
          exact
          path="/store/:language/customs-suite"
          element={<Suite />}
        />
        <Route
          exact
          path="/store/:language/product/clearvat"
          element={<ClearVAT />}
        />
        <Route
          exact
          path="/store/:language/product/clearcustoms"
          element={<ClearCustoms />}
        />
        <Route exact path="/store/:language/product/spot" element={<SPOT />} />
        <Route
          exact
          path="/store/:language/product/vatrules"
          element={<VATRules />}
        />
        <Route
          exact
          path="/store/:language/product/checkvat-id"
          element={<CheckVATID />}
        />
        <Route path="/store" element={<RedirectToDefaultLanguage />} />
        <Route path="*" element={<NotFound />} />
      </ReactRoutes>
      <Footer />
    </body>
  );
}

{
  /* <Route exact path="/myRoute/:language" element={<PageComponent />} /> */
}
